<template>
  <div class="clock"
    v-if="info&&info.isSelf">
    <div class="clock-header">
      <img :src="info.avatar"
        alt="">
      <h5>{{info.userName}}</h5>
      <p>我在<strong>{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}课堂</strong>学习</p>
      <p>已经学完「{{info.courseName}}」</p>
      <ul>
        <li>
          <h4>{{info.accumulateSignDays}}</h4>
          <p>累计打卡（天）</p>
        </li>
        <li>
          <h4>{{info.joinDays}}</h4>
          <p>加入{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}（天）</p>
        </li>
      </ul>
    </div>
    <div class="clock-content">
      <header>
        我的打卡进度<span @click="showRule = true">打卡规则 ></span>
      </header>
      <ul>
        <li v-for="(item, index) in signRecordList"
          :key="index">
          <img v-if="item === 1&&index < 6"
            src="../assets/images/clock/finished.png"
            alt="">
          <img v-else-if="index < 6"
            src="../assets/images/clock/unfinished.png"
            alt="">
          <img v-else
            src="../assets/images/clock/ended.png"
            @click="draw"
            alt="">
          <p :class="{'active': item === 1}">{{index + 1}}天</p>
        </li>
      </ul>
    </div>
    <div class="clock-footer" v-if="!isSign">
      <div @click="clock">打卡</div>
    </div>
    <div class="clock-mask"
      v-if="showRule">
      <div class="clock-mask-content">
        <div class="clock-mask-rule">
          <h3>打卡规则</h3>
          <h5>1.如何打卡？</h5>
          <p>完成当天的阅读内容→在学习链接内点击打卡，即可成功打卡。连续打卡7天，即可获得高额优惠券。</p>
          <h5>2.打卡可以获得什么奖励？</h5>
          <p>成功报名后，坚持学习打卡7天，可获得神秘奖励。</p>
          <h5>3.打卡有时间限制么？</h5>
          <p>当天的打卡任务需在当天的0点0分~23点59分之间完成。</p>
          <p>如果超时，则算打卡失败</p>
          <h5>4.打卡可以补打吗？</h5>
          <p>打卡不可以补打。</p>
          <h5>5.打卡奖励什么时候发放？</h5>
          <p>完成打卡任务发放，一起坚持7天，等待时间的回报。</p>

        </div>
        <img class="clock-mask-close"
            @click="showRule = false"
            src="../assets/images/clock/close.png"
            alt="">
      </div>
    </div>
    <div class="clock-mask"
      v-if="showShare"
      @click="showShare = false">
      <img class="clock-mask-share"
        @click.stop=""
        src="../assets/images/clock/share.png"
        alt="">
    </div>
    <div class="clock-mask"
      v-if="showDialog">
      <div class="clock-mask-content">
        <div class="clock-mask-dialog">
          <!-- <div v-if="dialogType === 1">
            <img src="../assets/images/clock/success.png"
              alt="">
            <h5>分享成功</h5>
            <p>请在朋友圈点击链接即可打卡成功</p>
          </div> -->
          <div v-if="dialogType === 2">
            <img src="../assets/images/clock/c_success.png"
              alt="">
            <h5>打卡成功</h5>
            <p>+1天</p>
          </div>
          <!-- <div v-if="dialogType === 3">
            <img src="../assets/images/clock/success.png"
              alt="">
            <h5>分享失败</h5>
            <p>未完成分享，需分享到朋友圈</p>
          </div> -->
          <div v-if="dialogType === 4">
            <img src="../assets/images/clock/success.png"
              alt="">
            <h5>打卡失败</h5>
            <p>您已完成当日打卡</p>
          </div>
          <em @click="showDialog = false">我知道了</em>
        </div>
      </div>

    </div>
  </div>
  <img v-else class="clock-poster" :src="info&&info.sharePoster"
    alt="">

</template>

<script>
import api from '@edu-fe/api'
import login from '@/utils/login'
export default {
  name: 'ClockSchedule',
  data () {
    return {
      info: '',
      clockDays: 3,
      showRule: false,
      showShare: false,
      showDialog: false,
      dialogType: 1,
      signRecordList: [], // 打卡列表
      canDraw: false, // 领取奖品资格
      isSign: false // 是否已打卡
    }
  },
  props: {
    courseList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  created () {
    this.checkLogin()
  },
  methods: {
    async init (res) {
      const data = await this.getInfo()
      this.info = data
      this.signRecordList = data.signRecordList.filter((item, index) => index < 7)
      this.canDraw = this.signRecordList.every(item => item === 1)
      this.isSign = data.isSign
      this.setShare({
        title: data.shareTitle,
        desc: data.shareContent,
        imgUrl: data.shareImg,
        link: window.location.href.split('?')[0] + `?userId=${this.info.userId}&chapterId=${this.$route.query.chapterId}&courseId=${this.$route.query.courseId}`
      })
    },
    async getInfo (shareMark = 'signShare') {
      const { data } = await api.clockIn.getShareState({
        chapterId: this.$route.query.chapterId, // '68379012317311e79d7efa163e07d73d'
        shareMark: shareMark,
        courseId: this.$route.query.courseId, // '08f5e121316011e79d7efa163e07d73d'
        userId: this.$route.query.userId || ''
      })
      return data
    },
    async clock () {
      const data = await this.getInfo('signIn')
      this.info = data
      this.signRecordList = data.signRecordList.filter((item, index) => index < 7)
      this.canDraw = this.signRecordList.every(item => item === 1)
      this.isSign = true
      if (data.isSign === 0) {
        this.openDialog(2)
      } else {
        this.openDialog(4)
      }
    },
    openDialog (type) {
      this.showDialog = true
      this.dialogType = type
    },
    draw () {
      if (!this.canDraw) return
      this.$toast.show({
        message: '你已成功领取99-20优惠券'
      })
    },
    setShare (shareData) {
      wx.onMenuShareAppMessage(shareData)
      wx.onMenuShareTimeline(shareData)
    },
    async checkLogin () {
      const wpsSid = await login.getWpsSid()
      return wpsSid || login.login()
    }
  },

  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
@import "../style/main";
.clock {
  width: 100%;
  min-height: 100vh;
  background: url("../assets/images/clock/bg.png") no-repeat;
  background-size: 100% auto;
  background-color: #ffaf6c;
  box-sizing: border-box;
  padding: use(106) 0 use(86);
  &-poster{
    width: 100%;
  }
  &-header {
    background: #ffffff;
    box-shadow: 0 use(15) use(55) 0 rgba(224, 64, 0, 0.48);
    border-radius: use(20);
    width: 92%;
    margin: 0 auto;
    text-align: center;
    padding-bottom: use(32);
    img {
      border: use(4) solid #fff;
      border-radius: 50%;
      width: use(145);
      height: use(145);
      margin-top: use(-74);
      background-color: #fff;
    }
    h5 {
      font-weight: bold;
      font-size: use(30);
      color: #333333;
      margin: use(16) auto use(25);
    }
    p {
      font-size: use(28);
      color: #333333;
      letter-spacing: 0.35px;
      text-align: center;
      line-height: 1.5;
    }
    ul {
      li {
        width: 48%;
        display: inline-block;
        margin-top: use(80);
        h4 {
          font-weight: bold;
          font-size: use(52);
          color: #333333;
          margin-bottom: use(15);
        }
        p {
          font-size: use(28);
          color: #999999;
        }
      }
      li:first-child {
        border-right: use(2) solid #ebebeb;
      }
    }
  }
  &-content {
    background: #ffffff;
    box-shadow: 0 use(15) use(55) 0 rgba(224, 64, 0, 0.48);
    border-radius: use(20);
    width: 92%;
    margin: 0 auto;
    text-align: center;
    padding-bottom: use(40);
    margin-top: use(36);
    overflow: hidden;
    header {
      font-weight: bold;
      font-size: use(30);
      color: #333333;
      line-height: use(90);
      text-align: left;
      padding: 0 use(30);
      background-color: #f8f8f8;
      span {
        font-size: use(24);
        color: #999999;
        float: right;
      }
    }
    ul {
      width: 95%;
      display: flex;
      margin: use(50) auto 0;
      li {
        flex: 1;
        img {
          width: 80%;
        }
        p {
          font-size: use(24);
          color: #999999;
          margin-top: use(10);
        }
        p.active {
          color: #ff634a;
        }
      }
    }
  }
  &-footer {
    width: 100%;
    height: use(120);
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    > div {
      background-image: linear-gradient(135deg, #ffb500 0%, #f48f00 100%);
      border-radius: use(8);
      font-weight: bold;
      font-size: use(32);
      color: #ffffff;
      text-align: center;
      line-height: use(88);
      width: 92%;
      margin: auto;
    }
  }
  &-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    &-content {
      width: use(530);
      background: #ffffff;
      box-shadow: 0 use(2) use(30) 0 rgba(189, 201, 209, 0.1);
      border-radius: use(10);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%);
    }
    &-rule {
      padding: use(40) use(30) use(50);
      max-height: 70vh;
      overflow-y: scroll;
      h3 {
        font-size: use(36);
        color: #333333;
        text-align: center;
        margin-bottom: use(40);
        font-weight: bold;
      }
      h5 {
        font-weight: bold;
        font-size: use(28);
        color: #999999;
        margin-bottom: use(40);
      }
      p {
        font-size: use(28);
        color: #999999;
        margin-bottom: use(40);
        line-height: 1.4;
      }
    }
    &-share {
      width: 80%;
      float: right;
      margin-right: use(50);
      margin-top: use(10);
    }
    &-dialog {
      text-align: center;
      padding: use(60) use(30);
      img {
        width: use(100);
        margin-bottom: use(25);
      }
      h5 {
        font-weight: bold;
        font-size: use(36);
        color: #333333;
        margin-bottom: use(28);
      }
      p {
        font-size: use(28);
        color: #999999;
        margin-bottom: use(54);
      }
      em {
        background-image: linear-gradient(135deg, #ffb500 0%, #f48f00 100%);
        border-radius: use(8);
        font-weight: bold;
        font-size: use(32);
        color: #ffffff;
        line-height: use(70);
        width: use(300);
        margin: 0 auto;
        display: block;
      }
    }
    &-close {
      position: absolute;
      bottom: use(-80);
      left: 50%;
      transform: translate(-50%, 0);
      width: use(56);
      height: use(56);
    }
  }
}
</style>
